
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./apertum-dex-sdk.cjs.production.min.js')
} else {
  module.exports = require('./apertum-dex-sdk.cjs.development.js')
}
